import { MDBBtn } from "mdb-react-ui-kit";

const Button = ({ type = "button", children, ...restProps }) => {
    return <MDBBtn type={type} {...restProps}>{children}</MDBBtn>;
};

export default Button;
